import * as React from 'react'
import { useIntl } from 'react-intl'
import MessagingLabel from 'LuxKit/Label/MessagingLabel'
import moment from 'moment'

const ALMOST_GONE_TAG = 'almost_gone'
const SELLING_FAST_TAG = 'selling_fast'
const TRENDING_TAG = 'trending'

const ENDING_SOON_THRESHOLD_DAYS = 7

interface Props {
  urgencyTags?: Array<string>;
  experience?: App.ExperienceOffer;
}

function getEarliestExpirationDate(experience?: App.ExperienceOffer): moment.Moment | undefined {
  const dates = [
    experience?.bookByDate,
    experience?.expirationDate,
  ]
    .filter(Boolean)
    .map((date) => moment(date))
    .filter((date) => date.isValid())

  if (!dates.length) return undefined

  return moment.min(dates)
}

function ExperienceUrgencyTag(props: Props) {
  const { urgencyTags, experience } = props

  const intl = useIntl()

  if (!urgencyTags?.length && !experience) return null

  const tags = urgencyTags ?? []

  if (tags.includes(ALMOST_GONE_TAG)) {
    return (
      <MessagingLabel variant="urgencyNormal">
        {intl.formatMessage({
          id: 'mr1jMv_mUehO3c3Ua-oa',
          defaultMessage: 'Almost gone',
          description: 'Urgency badge shown on experience offer tiles when availability is critically low',
        })}
      </MessagingLabel>
    )
  }

  const now = moment()
  const expirationDate = getEarliestExpirationDate(experience)
  const endingSoon = expirationDate ? !expirationDate.isBefore(now) && expirationDate.diff(now, 'days') <= ENDING_SOON_THRESHOLD_DAYS : false

  if (endingSoon) {
    return (
      <MessagingLabel variant="urgencyNormal">
        {intl.formatMessage({
          id: 'hCaG_y3T-9G9_zZtkcmT',
          defaultMessage: 'Ending soon',
          description: 'Urgency badge shown on experience offer tiles when the offer is ending soon',
        })}
      </MessagingLabel>
    )
  }

  if (tags.includes(SELLING_FAST_TAG)) {
    return (
      <MessagingLabel variant="successLight">
        {intl.formatMessage({
          id: '8zaSoYdyvcmL8GK9J2D_',
          defaultMessage: 'Selling fast',
          description: 'Urgency badge shown on experience offer tiles that are selling fast',
        })}
      </MessagingLabel>
    )
  }

  if (tags.includes(TRENDING_TAG)) {
    return (
      <MessagingLabel variant="successLight">
        {intl.formatMessage({
          id: 'G1j_QCxN3yznUN72mDQg',
          defaultMessage: 'Trending',
          description: 'Urgency badge shown on experience offer tiles that are trending',
        })}
      </MessagingLabel>
    )
  }

  return null
}

export default React.memo(ExperienceUrgencyTag)
